import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ProfileService } from 'src/app/modules/profile/profile.service';
import { AuthService } from '../../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordGuard implements CanActivate {
  role: string;
  token: string;

  constructor(
    private _authService: AuthService,
    private profileService: ProfileService,
    private _router: Router
  ) {
    this.token = this._authService.getToken();
  }

  canActivate() {
    return this._authService.getRole().pipe(
      switchMap(r => {
        this.role = r.result.ROLE;
        return this.profileService.getProfile().pipe(
          map(p => {
            if (this.token && (this.role === 'admin' || this.role === 'teacher' || this.role === 'psychologist' || (this.role === 'user' && p.result.TYPE_REGISTER === 0))) {
              return true;
            } else {
              this._router.navigate(['/']);
              return false;
            }
          })
        )
      }),
      catchError(() => {
        this._router.navigate(['/']);
        return of(false);
      })
    )
  }
}
